import React from "react";
import '@justinribeiro/lite-youtube';
import logoMobile from "../assets/images/parent-head-logo.png";
import logo from "../assets/images/bulle_header_parents.png";

function HeaderParent() {

	return (
		<div className="headerParent">
			<div className="headerParent__left-container">
                <img className="headerParent__desktop-img" src={logo} alt="Enfin un site pour savoir de quoi on parle" width="700" height="468" />
                <p className="headerParent__left-container-text">
					Vous êtes au contact d’enfants et vous souhaitez que l’on vous accompagne pour aborder les règles facilement et de manière ludique ? Vous êtes au bon endroit ! Bienvenue sur Parlons Règles, ici vous trouverez des ressources clés en main pour parler de règles sans tabou.
                </p>
			</div>
			<div className="headerParent__left-container-mobile">
				<div className="headerParent__logo-container">
					<img src={logoMobile} alt="" aria-hidden="true" width="600" height="191" />
				</div>
			</div>
			<div className="headerParent__video-container">
				<lite-youtube class="young-head__video" videoid="_5cuCH2E4_s" videoplay="Voir" videotitle="Marion, enseignante et référente règles dans un établissement scolaire" posterquality="maxresdefault" autopause>
					<a href="https://www.youtube.com/watch?v=_5cuCH2E4_s">Voir sur YouTube: "Marion, enseignante et référente règles dans un établissement scolaire"</a>
				</lite-youtube>
				<div className="headerParent__sub-video-container">
					<p className="headerParent__video-title">Devenir un établissement scolaire “règles friendly” : les initiatives inspirantes à mettre en place</p>
				</div>
			</div>
		</div>
	);
}

export default HeaderParent;
